import { Message, MessageType } from 'types'

const emptyMessage: Message = {
	type: 'TEXT' as MessageType,
	document: null,
	location: null,
	video: null,
	message: '',
	image: null,
	audio: null,
	contacts: null,
}

export default emptyMessage
